<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div @mouseover="mouseover($event, row[column.name], 'right')" @mouseout="mouseout" class="wy-va-optimization-response-name-cell">
    <div class="image">
      <el-button @click="handleClick(row)" v-if="row.savedResponse" slot="reference" class="saved-transcript-golden-star"></el-button>
      <el-button @click="handleClick(row)" v-else slot="reference" class="saved-transcript-grey-star"></el-button> 
      <span class="response-name" v-html="row[column.name]"></span> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'wy-va-optimization-response-name-cell',
  props: ['controller', 'column', 'row', 'index'],

  methods: {
    handleClick(row) {
      if(row.savedResponse){
        this.controller.removeSavedResponse(row)
      }
      else {
        this.controller.addSavedResponse(row)
      }
    },
    mouseover(e, tooltips, type) {
      e.stopPropagation();
      let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
      && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
      && e.target.className != 'el-select el-select--mini'

      if(e.target.classList.contains('response-name') || e.target.classList.contains('highlight-keywords')){
        if(tooltips && tooltips.trim() != '' && ignoreClassName) {
          let tooltipsEl = document.querySelector(".site-tooltips");
          if(tooltipsEl) {
            tooltipsEl.innerHTML = tooltips
            tooltipsEl.style.display = 'block';
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;

            if(type == "right") {
              tooltipsEl.style.right = "10px";
              tooltipsEl.style.left = "379px";
            }
            if(type == "left") {
              tooltipsEl.style.left = "10px";
              tooltipsEl.style.right = "unset";
            }
            if(!type || type == "normal") {
              tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + 10}px`;
            }
            tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
          }
        }
        else {
          e.preventDefault();
        }
      }
    },
    mouseout(e) {
      e.stopPropagation();
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
      }
    },
  }
}
</script>

<style lang="scss">
.wy-va-optimization-response-name-cell{
  text-align: left;
  .el-button {
    background: none;
  }
  span.response-name {
    font-weight: 500;
    // width: 260px;
    .highlight-keywords {
      background-color: rgba(255, 177, 0, 0.22);
    }
  }
  .saved-transcript-golden-star {
    float: left;
    margin-top: 0px;
    margin-right: 0px;
    background-image: url('../../assets/icons/icon_golden_star.svg');
    background-size: 16px;
    border: 0;
    width: 20px;
    background-repeat: no-repeat;
    height: 25px;
    padding: 0px;
    width: 10px;
    width: 20px;
    // margin-right: 15px;
    background-position-x: center;
    background-position-y: center;
  }
  .saved-transcript-grey-star {
    float: left;
    margin-top: 0px;
    margin-right: 0px;
    background-image: url('../../assets/icons/icon_grey_star.svg');
    background-size: 16px;
    border: 0;
    width: 20px;
    background-repeat: no-repeat;
    height: 25px;
    padding: 0px;
    width: 10px;
    width: 20px;
    // margin-right: 15px;
    background-position-x: center;
    background-position-y: center;
  }
}
</style>